"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getHasSeenInstantWin = void 0;

var _moment = _interopRequireDefault(require("moment"));

var getHasSeenInstantWin = function getHasSeenInstantWin(userChallenge) {
  var _ref = userChallenge || {},
      _ref$metaData = _ref.metaData;

  _ref$metaData = _ref$metaData === void 0 ? {} : _ref$metaData;
  var _ref$metaData$lastSee = _ref$metaData.lastSeenAt,
      lastSeenAt = _ref$metaData$lastSee === void 0 ? '' : _ref$metaData$lastSee,
      _ref$calculationState = _ref.calculationState;
  _ref$calculationState = _ref$calculationState === void 0 ? {} : _ref$calculationState;
  var _ref$calculationState2 = _ref$calculationState.finishedAt,
      finishedAt = _ref$calculationState2 === void 0 ? '' : _ref$calculationState2;

  if (lastSeenAt) {
    return (0, _moment["default"])(finishedAt).isBefore(lastSeenAt);
  }

  return null;
};

exports.getHasSeenInstantWin = getHasSeenInstantWin;
var _default = getHasSeenInstantWin;
exports["default"] = _default;
//# sourceMappingURL=getHasSeenInstantWin.js.map